import { axiosApi } from "../../../api/dbAxios";

export const fetchAllUserList = async () => {
  try {
    const response = await axiosApi.get(`/users/`);
    return response.data.filter((u: any) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(u?.email || "").trim()),
    );
  } catch (error) {
    console.error("Error fetching item list:", error);
    return [];
  }
};
